const appConfig = {
	apiURL: process.env.REACT_APP_BACKEND_URL || 'http://localhost:1337'
};

export { appConfig };
